import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { POST, GET } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

export const StepOne = createAsyncThunk(
  "/website/volunteer-stepform/stepone",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Volunteer_Stepform.StepOne, data);
      console.log("resresresresres", res)
      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);

    } catch (error) {
      console.log("this is my slice errror", error)
      return rejectWithValue(error);
    }
  }
);
export const StepTwo = createAsyncThunk(
  "/website/volunteer-stepform/steptwo",
  async (data, { rejectWithValue }) => {
    try {
      console.log("data", data)
      const res = await POST(APIS.Volunteer_Stepform.StepTwo, data);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetALL = createAsyncThunk(
  "/website/volunteer-stepform",
  async (volunteer_id, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Volunteer_Stepform.GetALL}?volunteer_id=${volunteer_id}`
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const Slice = createSlice({
  name: "volunteerstepform",
  initialState: {
    step1: null,
    step2: null,
    getall: null,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {
    resetVolunteerDetails: (state) => {
      state.data = null;
      state.status = IDS.SLICESTATUS.Idle;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(StepOne.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StepOne.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.step1 = action.payload;
      })
      .addCase(StepOne.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(StepTwo.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StepTwo.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.step2 = action.payload;
      })
      .addCase(StepTwo.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(GetALL.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetALL.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.getall = action.payload;
      })
      .addCase(GetALL.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export const { resetVolunteerDetails } = Slice.actions;
export default Slice.reducer;
